<template>
  <div id="classDetailsDiv">
    <div class="classDetailsDiv_content">
      <!--<div class="head_title class_head_title">
        <div class="head_title_font class_head_title_font">基础信息</div>
      </div>-->
      <div class="body_content class_body_content">
        <!-- 模态框（Modal） -->
        <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
          <div class="modal-dialog">
            <div class="modal-content query-modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                <h4 class="modal-title" id="myModalLabel">新增班主任</h4>
              </div>
              <div class="modal-body query-modal-body">
                <label>教师名称：</label>
                <input type="text" class="form-control queryInput" v-model="searchTeacherName" @keyup="loadQueryInputDataWhenAdd()"/>
                <div id="teachers_div">
                  <option v-for="(queryData,index) in queryInputDataArr" :key="index" :value="queryData.userName"
                          @click="putTeacherData(index)">{{queryData.userName}}-{{queryData.mobile}}</option>
                </div>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-default okBtn" @click="saveTeacherMsg_add()">确定</button>
                <button type="button" class="btn btn-default okBtn" data-dismiss="modal" @click="searchTeacherName=''">关闭</button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="classStatus != -1 && classInfoEditFlag==1">
          <div class="classDetailsDiv_content_one">
            <div class="class_head_title_self">
              <div class="head_title_font class_head_title_font">开班信息</div>
            </div>
            <div class="class_body_content_self">
              <table class="table table-striped table-bordered class_details_table">
                <tbody>
                <tr>
                  <th>班级名称</th>
                  <th>开班时间</th>
                  <th>结业时间</th>
                  <th>班级类型</th>
                  <th v-if="classStatus != -1">操作</th>
                </tr>
                <tr v-if="classStatus != -1">
                  <td>
                    <input type="text" v-validate="'required|maxL:100'" data-vv-scope="clazz" data-vv-as="班级名称" name="name" class="form-control classInfo" placeholder="输入班级名称" v-model="classInfo.name" autocomplete="off"/>
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('clazz.name') }}</span>
                  </td>
                  <td>
                    <input type="text" v-validate="{required:true, date_format:'yyyy-MM-dd',beforeDate:['结业时间',classInfo.endDate]}" data-vv-scope="clazz" data-vv-as="开班时间" ref="beforeDateTarget" name="startDate" class="form-control classInfo" id="startDate" placeholder="输入开班时间" readonly v-model="classInfo.startDate"/>
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('clazz.startDate') }}</span>
                  </td>
                  <td>
                    <input type="text" v-validate="'required|date_format:yyyy-MM-dd'" data-vv-scope="clazz" data-vv-as="结业时间" ref="afterDateTarget" name="endDate" class="form-control classInfo" id="endDate" placeholder="输入结业时间" readonly v-model="classInfo.endDate"/>
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('clazz.endDate') }}</span>
                  </td>
                  <td>
                    <form role="form" class="classType">
                      <select v-validate="'required'" data-vv-scope="clazz" data-vv-as="班级类型" name="clazzType" class="form-control classInfo" v-model="classInfo.type">
                        <option v-for="(clazzType,index) in clazz_type" :key="index" :value="index">{{clazzType}}</option>
                      </select>
                      <span class="spanRed">*</span>
                      <span class="validateTip">{{ errors.first('clazz.clazzType') }}</span>
                    </form>
                  </td>
                  <td>
                    <button type="button" class="btn btn-default btn_option okBtn" @click="saveClassMsg('clazz')">确定</button>
                  </td>
                </tr>
                <tr v-else>
                  <td>{{classInfo.name}}</td>
                  <td>{{classInfo.startDate}}</td>
                  <td>{{classInfo.endDate}}</td>
                  <td>{{classInfo.type |formatType}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="classDetailsDiv_content_one" :class="{no_show: clazzId == ''}">
            <div class="class_head_title_self">
              <div class="head_title_font class_head_title_font">班主任</div>
            </div>
            <div class="class_body_content_self">
              <table class="table table-striped table-bordered class_details_table">
                <tbody>
                <tr>
                  <th width="15%">人员姓名</th>
                  <th width="15%">角色</th>
                  <!--<th>所属部门</th>-->
                  <th width="15%">联系电话</th>
                  <th width="15%">邮箱</th>
                  <th width="15%">办公地点</th>
                  <th width="15%">操作</th>
                </tr>
                <tr v-for="(teacherClazzInfo, index) in teacherClazzInfoList" :key="index">
                  <td width="15%" class="teacherName">{{teacherClazzInfo.teacherName}}</td>
                  <td width="15%">
                    <select class="form-control teacherInfo" v-model="teacherClazzInfo.type">
                      <option>班主任</option>
                      <option>副班主任</option>
                    </select>
                    <span class="spanRed">*</span>
                  </td>
                  <!--<td class="teacherName">
                    &lt;!&ndash;<input type='text' class="form-control" placeholder="输入所属部门" v-model="teacherClazzInfo.dept"/>&ndash;&gt;
                    {{teacherClazzInfo.dept}}
                  </td>-->
                  <td width="15%">
                    <input type="text" v-validate="'required|numeric|mobile'" :data-vv-scope="'teacherClazz'+index" data-vv-as="联系电话" name="tel" class="form-control teacherInfo" placeholder="输入联系电话" v-model="teacherClazzInfo.tel"/>
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('teacherClazz'+index+'.tel') }}</span>
                  </td>
                  <td width="15%">
                    <input type="text" v-validate="'email'" :data-vv-scope="'teacherClazz'+index" data-vv-as="邮箱" name="mail" class="form-control teacherInfo" placeholder="输入邮箱" v-model="teacherClazzInfo.mail"/>
                    <span class="validateTip">{{ errors.first('teacherClazz'+index+'.mail') }}</span>
                  </td>
                  <td width="15%">
                    <input type="text" v-validate="'required'" :data-vv-scope="'teacherClazz'+index" data-vv-as="办公地点" name="office" class="form-control teacherInfo" placeholder="输入办公地点" v-model="teacherClazzInfo.office"/>
                    <span class="spanRed">*</span>
                    <span class="validateTip">{{ errors.first('teacherClazz'+index+'.office') }}</span>
                  </td>
                  <td width="15%">
                    <button type="button" class="btn btn-default btn_option okBtn" @click="tea_update_id=teacherClazzInfo.id;saveTeacherMsg_update(index)">确定</button>
                    <button type="button" class="btn btn-default btn_option okBtn" @click="tea_delete_id=teacherClazzInfo.id;deleteTeacherMsg()">删除</button>
                  </td>
                </tr>
                <!--<tr v-if="isAddTeacher">
                  <td class="teacherName">{{new_teacherMsg.new_teacherName}}</td>
                  <td>
                    <select class="form-control" v-model="new_teacherMsg.new_type">
                      <option>班主任</option>
                      <option>副班主任</option>
                    </select>
                  </td>
                  &lt;!&ndash;<td class="teacherName">
                    &lt;!&ndash;<input type='text' class="form-control" placeholder="输入所属部门" v-model="new_teacherMsg.new_dept"/>&ndash;&gt;
                    {{new_teacherMsg.new_dept}}
                  </td>&ndash;&gt;
                  <td>
                    <input type="text" class="form-control" placeholder="输入联系电话" v-model="new_teacherMsg.new_tel"/>
                  </td>
                  <td>
                    <input type="text" class="form-control" placeholder="输入邮箱" v-model="new_teacherMsg.new_mail"/>
                  </td>
                  <td>
                    <input type="text" class="form-control" placeholder="输入办公地点" v-model="new_teacherMsg.new_office"/>
                  </td>
                  <td>
                    <button type="button" class="btn btn-default okBtn" @click="saveTeacherMsg_add()">确定</button>
                    <button type="button" class="btn btn-default okBtn" @click="isAddTeacher = false">删除</button>
                  </td>
                </tr>-->
                </tbody>
              </table>
              <button class="btn btn-default btn_option" @click="addTeacher_click()"><strong>+</strong></button>
            </div>
          </div>

          <div class="classDetailsDiv_content_one" :class="{no_show: clazzId == ''}">
            <div class="class_head_title_self">
              <div class="head_title_font class_head_title_font">食宿安排</div>
            </div>
            <div class="class_body_content_self">
              <table class="table table-striped table-bordered class_details_table">
                <tbody>
                <tr>
                  <th width="10%">宿舍安排</th>
                  <th width="15%">宿舍入住时间</th>
                  <th width="40%">就餐安排</th>
                  <th width="25%">备注</th>
                  <th width="10%">操作</th>
                </tr>
                <tr>
                  <td width="10%">
                    <input type="text" name="name" class="form-control dormitory_arrangement" placeholder="输入宿舍安排" v-model="hotel.name"/>
                    <!-- <span class="spanRed">*</span>
                     <span class="validateTip">{{ errors.first('foodRoom.name') }}</span>-->
                  </td>
                  <td width="15%">
                    <input class="form-control room dormitory_time" size="16" type="text" name="roommateDate" id="roommateDate" placeholder="输入宿舍入住时间" v-model="hotel.time" readonly/>
                  </td>
                  <td width="40%">
                    <div>
                      <input type='text' name="canteenOne" class="form-control food_room" placeholder="早餐地点" v-model="canteen[0].canteen"/>
                      <!--  <span class="spanRed">*</span>-->
                      <input type='time' class="form-control food_timeStart" placeholder="开餐时间" v-model="canteen[0].startTime"/><p>—</p>
                      <input type='time' class="form-control food_timeEnd" placeholder="结束时间" v-model="canteen[0].endTime"/>
                      <!--<span class="validateTip">{{ errors.first('foodRoom.canteenOne') }}</span>-->
                    </div>
                    <div>
                      <input type='text' name="canteenTwo" class="form-control food_room" placeholder="午餐地点" v-model="canteen[1].canteen"/>
                      <!--<span class="spanRed">*</span>-->
                      <input type='time' class="form-control food_timeStart" placeholder="开餐时间" v-model="canteen[1].startTime"/><p>—</p>
                      <input type='time' class="form-control food_timeEnd" placeholder="结束时间" v-model="canteen[1].endTime"/>
                      <!-- <span class="validateTip">{{ errors.first('foodRoom.canteenTwo') }}</span>-->
                    </div>
                    <div>
                      <input type='text' name="canteenThree" class="form-control food_room" placeholder="晚餐地点" v-model="canteen[2].canteen"/>
                      <!--<span class="spanRed">*</span>-->
                      <input type='time' class="form-control food_timeStart" placeholder="开餐时间" v-model="canteen[2].startTime"/><p>—</p>
                      <input type='time' class="form-control food_timeEnd" placeholder="结束时间" v-model="canteen[2].endTime"/>
                      <!--<span class="validateTip">{{ errors.first('foodRoom.canteenThree') }}</span>-->
                    </div>
                  </td>
                  <td width="25%">
                    <textarea class="form-control note" rows="6" placeholder="输入备注" v-model="classInfo.ssSummary"></textarea>
                  </td>
                  <td width="10%">
                    <button type="button" class="btn btn-default btn_option dormitory_arrangement okBtn" @click="saveClassMsg('foodRoom')">确定</button>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div v-else>
          <div class="classDetailsDiv_content_one">
            <div class="class_head_title_self">
              <div class="head_title_font class_head_title_font">开班信息</div>
            </div>
            <div class="class_body_content_self">
              <table class="table table-striped table-bordered class_details_table">
                <tbody>
                <tr>
                  <th>班级名称</th>
                  <th>开班时间</th>
                  <th>结业时间</th>
                  <th>班级类型</th>
                  <!-- <th>操作</th>-->
                </tr>
                <tr>
                  <td>{{classInfo.name}}</td>
                  <td>{{classInfo.startDate}}</td>
                  <td>{{classInfo.endDate}}</td>
                  <td>{{classInfo.type |formatType}}</td>
                  <!--  <td>
                      <div class="edit_pic" v-if="classStatus != '-1'" data-toggle="tooltip" data-placement="bottom" title="编辑"></div>
                      <div class="edit_pic_dis" v-else disabled data-toggle="tooltip" data-placement="bottom" title="编辑"></div>
                    </td>-->
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="classDetailsDiv_content_one">
            <div class="class_head_title_self">
              <div class="head_title_font class_head_title_font">班主任</div>
            </div>
            <div class="class_body_content_self">
              <table class="table table-striped table-bordered class_details_table">
                <tbody>
                <tr>
                  <th width="20%">人员姓名</th>
                  <th width="20%">角色</th>
                  <!-- <th>所属部门</th>-->
                  <th width="20%">联系电话</th>
                  <th width="20%">邮箱</th>
                  <th width="20%">办公地点</th>
                </tr>
                <tr v-for="(teacherClazzInfo, index) in teacherClazzInfoList" :key="index">
                  <td width="20%">{{teacherClazzInfo.teacherName}}</td>
                  <td width="20%"> {{teacherClazzInfo.type}}</td>
                  <!--<td>{{teacherClazzInfo.dept}}</td>-->
                  <td width="20%">{{teacherClazzInfo.tel}}</td>
                  <td width="20%">{{teacherClazzInfo.mail}}</td>
                  <td width="20%">{{teacherClazzInfo.office}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="classDetailsDiv_content_one">
            <div class="class_head_title_self">
              <div class="head_title_font class_head_title_font class_details_table">食宿安排</div>
            </div>
            <div class="class_body_content_self">
              <table class="table table-striped table-bordered class_details_table">
                <tbody>
                <tr>
                  <th width="10%">宿舍安排</th>
                  <th width="10%">宿舍入住时间</th>
                  <th width="30%">就餐安排</th>
                  <th width="50%" >备注</th>
                </tr>
                <tr>
                  <td width="10%">{{hotel.name}}</td>
                  <td width="10%">{{hotel.time}}</td>
                  <td width="30%">
                    <div v-for="(can, index) in canteen" :key="index">
                      {{can.canteen}} {{can.startTime}} —— {{can.endTime}}
                    </div>
                  </td>
                  <td width="50%">{{classInfo.ssSummary}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {schoolAxios} from "../main";
  import {getContentSize} from './mainView';

  import dictionaryData from '../json/dictionary';

  import {Validator} from 'vee-validate';

  export default {
    name: "openClassMessage",
    data() {
      return {
        clazzId: this.$store.state.clazzId,
        publishStatus: this.$store.state.publishStatus,
        classStatus: this.$store.state.classStatus,
        classInfoEditFlag:this.$store.state.classInfoEditFlag,
        //今日日期
        timeDate: '',
        /*
        开班信息
         */
        //办学方式选择列表
        clazz_type: dictionaryData.clazz_type,
        classInfo: {
          name: '',
          startDate: '',
          endDate: '',
          type: '',
          ssSummary: '' +
            '住宿总服台号码，外线（0477）8392511、（0477）8392588、（0477）8392599，内线1588或1599；房间之间直接拨房号即可，市话请先拨“0”。\n' +
            'WIFI名称：Erdsdx;WIFI密码：eRdsdx007\n' +
            '餐饮联系电话：（0477）8392788、（0477）8392755、（0477）8392799\n'
        },

        /*
        班主任
         */
        teacherClazzInfoList: [],
        isAddTeacher: false,
        new_teacherMsg: {
          new_id: '',
          new_teacherName: '',
          new_type: '',
          //new_dept: '',
          new_tel: '',
          new_mail: '',
          new_office: '',
        },
        //联想班主任信息
        searchTeacherName: '',
        queryInputDataArr: [],

        tea_update_id: '',
        tea_delete_id: '',

        /*
        食宿安排
         */
        hotel: {
          name: "一号公寓",
          time: ""
        },
        canteen: [
          {canteen:"餐饮中心",startTime:"07:30",endTime:"09:00"},
          {canteen:"餐饮中心",startTime:"12:00",endTime:"13:00"},
          {canteen:"餐饮中心",startTime:"18:00",endTime:"19:00"}
        ],
        roommateDate: ''
      }
    },
    filters: {
      formatType(value){
        let this_ = this;
        if(dictionaryData.clazz_type && value){
          value = dictionaryData.clazz_type[value];
        }
        return value;
      }
    },
    created: function () {

    },
    mounted: function () {
      let this_ = this;
      this.$nextTick(function () {
        getContentSize();
        //日期
        this_.dateDefault();

        this_.initOpenClassMessageData();

        // this_.loadValidator();
      });
    },
    methods: {
     /* loadValidator(){
        let this_ = this;
        //日期之前验证
        const isBeforeDate = {
          validate: function (value, args) {
            let date1 = new Date(value);
            let obj = this_.$refs.afterDateTarget.value;
            if(obj){
              let data2 = new Date(obj);
              return date1.getTime() <= data2.getTime();
            }else {
              return true;
            }
          }
        }
        Validator.extend('beforeDate', isBeforeDate);
        //日期之后验证
        const isAfterDate = {
          validate: function (value, args) {
            let date1 = new Date(value);
            let obj = this_.$refs.beforeDateTarget.value;
            if(obj){
              let data2 = new Date(obj);
              return date1.getTime() >= data2.getTime();
            }else {
              return true;
            }
          }
        }
        Validator.extend('afterDate', isAfterDate);
      },*/
      /**
       * 初始加载数据
       */
      initOpenClassMessageData(){
        // console.info(this.classInfoEditFlag+"----"+this.classStatus+"--"+(this.classStatus != -1 && this.classInfoEditFlag));
        let this_=this;
        if(this_.clazzId){
          schoolAxios({
            method: 'get',
            url: 'clazz/load/'+this_.clazzId,
            params:{}
          }).then(function (response) {
            let data = response.data;
            if(data.success){
              this_.classInfo = data.data;
              if(data.data.hotel){
                this_.hotel = JSON.parse(data.data.hotel);
              }
              if(data.data.canteen){
                this_.canteen = JSON.parse(data.data.canteen);
              }
            }
          });
          schoolAxios({
            method:'get',
            url: 'teacherClazz/findTeacherClazz',
            params:{
              'clazzId':this_.clazzId
            }
          }).then(function (response) {
            let data=response.data;
            if(data.success){
              this_.teacherClazzInfoList=data.list;
            }
          });
        }
      },
      /**
       * 保存或修改开班信息
       */
      saveClassMsg(flag){
        let this_ = this;
        this_.$validator.validateAll(flag).then(result => {
          if (result) {
            schoolAxios({
              method: 'post',
              url: 'clazz/add',
              data: {
                'id': this_.clazzId,
                'name': this_.classInfo.name,
                'startDate': this_.classInfo.startDate,
                'endDate': this_.classInfo.endDate,
                'type': this_.classInfo.type,
                'hotel': JSON.stringify(this_.hotel),
                'canteen': JSON.stringify(this_.canteen),
                'ssSummary': this_.classInfo.ssSummary,
              }
            }).then(function (resp) {
              let data = resp.data;
              if(data.success){
                "保存成功".showMessage();
                this_.clazzId = data.data;

                this_.$store.set("clazzId", this_.clazzId);
                this_.$store.set("publishStatus", this_.publishStatus);
                this_.$store.set("classStatus", this_.classStatus);
                this_.dateDefault();
              }else {
                (data.message||"保存失败").showMessage();
              }
            });
          }
        })
      },
      /**
       * 新增班主任
       */
      saveTeacherMsg_add(){
        let this_ = this;

        if(this_.new_teacherMsg.new_id != ""){
          this_.isAddTeacher = true;
        }else{
          "请选择合法的班主任".showMessage();
          return;
        }
        schoolAxios({
          method: 'post',
          url: 'teacherClazz/add',
          data: {
            'type': this_.new_teacherMsg.new_type,
            'clazzId': this.clazzId,
            'teacherId': this_.new_teacherMsg.new_id,
            'teacherName': this_.new_teacherMsg.new_teacherName,
            'tel': this_.new_teacherMsg.new_tel,
            'mail': this_.new_teacherMsg.new_mail,
            'office': this_.new_teacherMsg.new_office,
            'force':this_.forceSaveTeacher
          }
        }).then(function (resp) {
          let data = resp.data;
          this_.forceSaveTeacher = 0;
          if(data.success){
            this_.isAddTeacher = false;
            this_.searchTeacherName = "";
            this_.new_teacherMsg.new_id = "";
            this_.initOpenClassMessageData();
            $("#myModal").modal("hide");
          }else{
            let message = data.message;
            if(message && message.startsWith('本时段内')){
              message.showConfirm(function () {
                this_.forceSaveTeacher = 1;
                this_.saveTeacherMsg_add();
              });
            }else
            (data.message||"保存失败").showMessage();
          }
        })
      },
      /**
       * 修改班主任
       */
      saveTeacherMsg_update(index){
        let this_ = this;
        // console.info(this_.$validator.validate());
        this_.$validator.validateAll('teacherClazz' + index ).then(result => {
          if (result) {
            let updateData = this_.teacherClazzInfoList[index];
            schoolAxios({
              method: 'put',
              url: 'teacherClazz/edit',
              data: {
                'id': updateData.id,
                'type': updateData.type,
                'tel': updateData.tel,
                'mail': updateData.mail,
                'office': updateData.office
              }
            }).then(function (resp) {
              let data = resp.data;
              if (data.success) {
                "保存成功".showMessage();
                this_.initOpenClassMessageData();
              } else {
                "保存失败".showMessage();
              }
            });
          }
        });
      },
      /**
       * 删除班主任
       */
      deleteTeacherMsg(){
        let this_ = this;
        "确定删除".showConfirm(function () {
          schoolAxios({
            method: 'delete',
            url: 'teacherClazz/delete/'+this_.tea_delete_id,
            params: {}
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              this_.initOpenClassMessageData();
            }else{
              "删除失败".showMessage();
            }
          });
        })
      },
      /**
       * 点击添加老师
       */
      addTeacher_click(){
        let this_ = this;
        $("#myModal").modal("show");
      },
      /**
       * 联想查询班主任信息-add
       */
      loadQueryInputDataWhenAdd(){
        let this_ = this;
        if(this_.searchTeacherName != ""){
          //后台查询数据赋值
          schoolAxios({
            method: 'get',
            url: 'user/queryUserSchoolByUserName',
            params: {
              'userName': this_.searchTeacherName
            }
          }).then(function (resp) {
            let data = resp.data;
            if(data.success){
              this_.queryInputDataArr = data.list;
              $("#teachers_div").show();
            }
          });
        }else{
          this_.queryInputDataArr= [];
        }
      },
      /**
       * 新增老师时获得数据
       */
      putTeacherData(index){
        let this_ = this;
        if(index >= 0){
          let data = this_.queryInputDataArr[index];

          this_.new_teacherMsg.new_id = data.id;
          this_.new_teacherMsg.new_teacherName = data.userName;
          this_.new_teacherMsg.new_type = '班主任';
          //this_.new_teacherMsg.new_dept = data.orgName;
          this_.new_teacherMsg.new_tel = data.mobile;
          this_.new_teacherMsg.new_mail = data.email;
          this_.new_teacherMsg.new_office = '';

          this_.searchTeacherName = data.userName;
          $("#teachers_div").hide();
        }
      },
      /**
       * 验证数据是否为空
       * @param flag 保存类型
       */
      validateDataIsEmpty(flag){
        let this_ = this;

        if(flag == 'class'){
          if(this_.classInfo.name == ""){
            "请输入班级名称".showMessage();
            return false;
          }
          if(this_.classInfo.startDate == ""){
            "请输入开课时间".showMessage();
            return false;
          }
          if(this_.classInfo.endDate == ""){
            "请输入结业时间".showMessage();
            return false;
          }
          if(this_.classInfo.type == ""){
            "请选择办学方式".showMessage();
            return false;
          }
        }

        return true;
      },
      /**
       * 初始化日期选这框
       */
      dateDefault(){
        let this_ = this;
        let date, nowDate;
        date = new Date();
        nowDate = date.getFullYear() + "-";
        nowDate += (date.getMonth() + 1) + "-";
        nowDate += date.getDate() + " ";
        this_.timeDate = nowDate;
        $('#startDate').datetimepicker({
          minView: "month",//选择日期后，不会再跳转去选择时分秒
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,//选择一个日期后是否立即关闭此选择框
          todayHighlight: true,//高亮当前日期
          startView: 2,// 日期时间选择器打开之后首先显示的视图，默认值为：2，0:hour,1:day,2:mouth,3:year,4:decade
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#startDate").val();
          this_.classInfo.startDate = value;

          ev.preventDefault();
          ev.stopPropagation();
        });
        $('#endDate').datetimepicker({
          minView: "month",
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,
          todayHighlight: true,
          startView: 2,
          forceParse: 0,
          showMeridian: 1,
        }).on('hide', function (ev) {
          let value = $("#endDate").val();
          this_.classInfo.endDate = value;

          ev.preventDefault();
          ev.stopPropagation();
        });
        $('#roommateDate').datetimepicker({
          minView: "month",
          language: 'zh-CN',
          format: 'yyyy-mm-dd',
          //startDate: this_.timeDate,
          weekStart: 0,
          todayBtn: true,
          clearBtn: true,
          autoclose: true,
          todayHighlight: true,
          startView: 2,
          forceParse: 0,
          showMeridian: 1,
          pickerPosition:'top-right'
        }).on('hide', function (ev) {
          let value = $("#roommateDate").val();
          this_.hotel.time = value;
          this_.roommateDate = value;

          ev.preventDefault();
          ev.stopPropagation();
        });
      },
    }
  }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/openClassMessage.css";
</style>



// WEBPACK FOOTER //
// src/components/openClassMessage.vue